export const BOT_USER_ID = -2;